import { ABAC_RULES } from './constants'

export function buildRbacRulesForRole (roleId, permissionKeys = []) {
  const roleRules = {}
  for (const key of permissionKeys) {
    roleRules[key] = true
  }

  return {
    [roleId]: roleRules,
    ...ABAC_RULES
  }
}
